export interface Rgb {
    r: number;
    g: number;
    b: number;
}

export interface Hsv {
    h: number;
    s: number;
    v: number;
}

export function rgbToHex({ r, g, b }: Rgb): string {
    return pad(r.toString(16)).toUpperCase() +
        pad(g.toString(16)).toUpperCase() +
        pad(b.toString(16)).toUpperCase();
}

export function hexToRgb(hex: string): Rgb {
    const rgb = /^([A-F\d]{2})([A-F\d]{2})([A-F\d]{2})$/i.exec(hex);

    return {
        r: parseInt(rgb[1], 16),
        g: parseInt(rgb[2], 16),
        b: parseInt(rgb[3], 16)
    };
}

const RGB_STRING_REGEX = /^rgb\(([\d]{1,3}), ([\d]{1,3}), ([\d]{1,3})\)$/i;

export function isRgbString(rgbString: string): boolean {
    const rgb = RGB_STRING_REGEX.exec(rgbString);

    return rgb !== null;
}

export function rgbStringToHex(rgbString: string): string {
    const rgb = RGB_STRING_REGEX.exec(rgbString);

    return pad(Number(rgb[1]).toString(16)).toUpperCase() +
        pad(Number(rgb[2]).toString(16)).toUpperCase() +
        pad(Number(rgb[3]).toString(16)).toUpperCase();
}

// "Stolen" from TinyColor.
// https://github.com/bgrins/TinyColor
export function rgbToHsv(rgb: Rgb): Hsv {
    const r = bound01(rgb.r, 255);
    const g = bound01(rgb.g, 255);
    const b = bound01(rgb.b, 255);

    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    const d = max - min;

    let h: number;
    const s = max === 0 ? 0 : d / max;
    const v = max;

    if (max === min) {
        h = 0;
    } else {
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
            default:
        }

        h /= 6;
    }

    return { h, s, v };
}

// "Stolen" from TinyColor.
// https://github.com/bgrins/TinyColor
export function hsvToRgb(hsv: Hsv): Rgb {
    const h = hsv.h * 6;
    const { s, v } = hsv;

    const i = Math.floor(h);
    const f = h - i;
    const p = v * (1 - s);
    const q = v * (1 - f * s);
    const t = v * (1 - (1 - f) * s);
    const mod = i % 6;
    const r = [ v, q, p, p, t, v ][mod];
    const g = [ t, v, v, q, p, p ][mod];
    const b = [ p, p, t, v, v, q ][mod];

    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
    };
}

export function getDoneIconColor(swatchColor: string) {
    const rgb = hexToRgb(swatchColor);
    const hsv = rgbToHsv(rgb);

    if (hsv.v < 0.8) {
        return 'FFFFFF';
    }

    return '000000';
}

function pad(s: string): string {
    return s.length === 1 ? `0${s}` : s;
}

// "Stolen" from TinyColor.
// https://github.com/bgrins/TinyColor
function bound01(n: number, max: number) {
    n = Math.min(max, Math.max(0, n));

    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    return (n % max) / max;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/color-picker/utils.tsx
 **/